import { Divider as MUIDivider, type DividerProps } from '@mui/material'
import type { FC } from 'react'

export const Divider: FC<DividerProps> = props => (
  <MUIDivider
    {...props}
    sx={{
      ...props.sx,
      my: 1,
      fontSize: theme => theme.typography.caption.fontSize,
      color: 'text.secondary',
      textTransform: 'uppercase',
    }}
  />
)
